import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import isDev from '@configuratorware/configurator-frontendgui/Utils/Dev/isDev';
import DevelopmentErrorPage from '@configuratorware/configurator-frontendgui/App/Error/DevelopmentErrorPage';
import ProductionErrorPage from '@configuratorware/configurator-frontendgui/App/Error/ProductionErrorPage';
import CustomHeaderContainer from "../../Containers/CustomHeader/CustomHeaderContainer";
import { Typography } from "@material-ui/core";

class ErrorBoundary extends React.Component {
    static propTypes = {
        children: PropTypes.object,
        hasNoAccess: PropTypes.bool,
        errorMessage: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, info: null };
    }

    componentDidCatch(error, info) {
        this.setState({ hasError: true, error, info });
        // @todo: log the error to an error reporting service (we should create one...)
        // eslint-disable-next-line no-console
        console.error(error, info);
    }

    render() {
      if(this.props.hasNoAccess) {
        return (
          <div>
            <CustomHeaderContainer />
            <Typography
              variant="h4"
              style={{ display: "flex", justifyContent: "center" }}
            >
              {this.props.errorMessage}
            </Typography>
          </div>
        )
      }
        if (this.state.hasError && isDev()) {
            return <DevelopmentErrorPage info={this.state.info} error={this.state.error} />;
        } else if (this.state.hasError) {
            return <ProductionErrorPage />;
        } else {
            return this.props.children;
        }
    }
}

const mapStateToProps = ({ configurator }) => {

  return {
    hasNoAccess: configurator.hasNoAccess,
    errorMessage: configurator.errorMessage,
  };
};

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary);